import { render, staticRenderFns } from "./assessRiskRegisterStatus.vue?vue&type=template&id=b0c4b100"
import script from "./assessRiskRegisterStatus.vue?vue&type=script&lang=js"
export * from "./assessRiskRegisterStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0c4b100')) {
      api.createRecord('b0c4b100', component.options)
    } else {
      api.reload('b0c4b100', component.options)
    }
    module.hot.accept("./assessRiskRegisterStatus.vue?vue&type=template&id=b0c4b100", function () {
      api.rerender('b0c4b100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRegister/assessRiskRegisterStatus.vue"
export default component.exports